var _circle, _circle2, _circle3, _path, _path2, _text, _text2, _text3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEntityStructureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 20,
    r: 8,
    fill: "#DACEE0",
    stroke: "#ACB1BB",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 45,
    r: 6,
    fill: "#C1D1F0",
    stroke: "#ACB1BB",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 6,
    fill: "#E8D3C6",
    stroke: "#ACB1BB",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 25L19 40",
    stroke: "#ACB1BB",
    strokeWidth: 1.5,
    strokeDasharray: "3,3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 25L41 40",
    stroke: "#ACB1BB",
    strokeWidth: 1.5,
    strokeDasharray: "3,3"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 25,
    textAnchor: "middle",
    fill: "#1A1B1D",
    fontSize: 8,
    fontWeight: 600,
    fontFamily: "Circular Std"
  }, "ME")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 49,
    textAnchor: "middle",
    fill: "#1A1B1D",
    fontSize: 6,
    fontWeight: 600,
    fontFamily: "Circular Std"
  }, "A")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 49,
    textAnchor: "middle",
    fill: "#1A1B1D",
    fontSize: 6,
    fontWeight: 600,
    fontFamily: "Circular Std"
  }, "B")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntityStructureIcon);
export default __webpack_public_path__ + "static/media/entity-structure-icon.a99a0e36fb3f72d13a0b9cb5ee9b4bea.svg";
export { ForwardRef as ReactComponent };